import { Messages } from '../../../codegen/Localize';
import { Order } from '../../helpers/Order';
import { IOrderClause } from '../../ServerApi/types/IOrderClause';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';

export const mixedContentInCrassSortOptions: OptionsDictionary = {
    'relevance': SortOptions.relevance,
    'name': {
        id: 'name',
        getMenuItemDisplayValue: Messages.column_name,
        subSortOptions: {
            'asc': {
                id: 'name.asc',
                field: 'title',
                getMenuItemDisplayValue: Messages.sortByAZ,
                getButtonDisplayValue: Messages.sortByNameAsc,
                ascending: true,
                toOrderClauseArray: () => [Order.asc('title')]
            },
            'desc': {
                id: 'name.desc',
                field: 'title',
                getMenuItemDisplayValue: Messages.sortByZA,
                getButtonDisplayValue: Messages.sortByNameDesc,
                ascending: false,
                toOrderClauseArray: () => [Order.desc('title')]
            }
        }
    },
    'type': {
        id: 'type.asc',
        field: 'type',
        getMenuItemDisplayValue: Messages.column_content_type,
        getButtonDisplayValue: Messages.column_content_type,
        ascending: true,
        toOrderClauseArray: () => [Order.asc('type')]
    },
    'viewOptions': {
        id: 'viewOptions',
        getMenuItemDisplayValue: Messages.view,
        subSortOptions: {
            'viewHitsDesc': {
                id: 'viewHits.desc',
                field: 'hitsTotal',
                ascending: false,
                getMenuItemDisplayValue: Messages.sortByHitsTotalDesc,
                getButtonDisplayValue: Messages.sortByHitsTotalDesc,
                toOrderClauseArray: () => [{type: 'view', field: 'hitsTotal', ascending: false}]
            },
            'viewHitsAsc': {
                id: 'viewHits.asc',
                field: 'hitsTotal',
                ascending: true,
                getMenuItemDisplayValue: Messages.sortByHitsTotalAsc,
                getButtonDisplayValue: Messages.sortByHitsTotalAsc,
                toOrderClauseArray: () => [{type: 'view', field: 'hitsTotal', ascending: true}]
            }
        }
    },
    'workbookOptions': {
        id: 'workbookOptions',
        getMenuItemDisplayValue: Messages.workbook,
        subSortOptions: {
            'workbookSheetsDesc': {
                id: 'workbookSheets.desc',
                field: 'sheetCount',
                ascending: false,
                getMenuItemDisplayValue: Messages.sortByNumSheetsDesc,
                getButtonDisplayValue: Messages.sortByNumSheetsDesc,
                toOrderClauseArray: () => [{type: 'workbook', field: 'sheetCount', ascending: false}]
            },
            'workbookSheetsAsc': {
                id: 'workbookSheets.asc',
                field: 'sheetCount',
                ascending: true,
                getMenuItemDisplayValue: Messages.sortByNumSheetsAsc,
                getButtonDisplayValue: Messages.sortByNumSheetsAsc,
                toOrderClauseArray: () => [{type: 'workbook', field: 'sheetCount', ascending: true}]
            }
        }
    }
};

export const mixedContentInCrassDefaultSortOrder = SortOptions.relevance.toOrderClauseArray() as IOrderClause[];

export const dataKeyToCrassFieldMap: Record<string, string> = {
    'name': 'title',
    'numSheets':  'sheetCount',
    'hitsTotal': 'hitsTotal',
    'connectedWorkbooksCount': 'connectedWorkbooksCount' ,
    'ownerName': 'ownerName',
    'updatedAt': 'modifiedTime'
};
